/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeType } from './ChallengeType';
import {
    ChallengeTypeFromJSON,
    ChallengeTypeFromJSONTyped,
    ChallengeTypeToJSON,
    ChallengeTypeToJSONTyped,
} from './ChallengeType';
import type { NonceAttestationData } from './NonceAttestationData';
import {
    NonceAttestationDataFromJSON,
    NonceAttestationDataFromJSONTyped,
    NonceAttestationDataToJSON,
    NonceAttestationDataToJSONTyped,
} from './NonceAttestationData';

/**
 * 
 * @export
 * @interface NonceAttestation
 */
export interface NonceAttestation {
    /**
     * 
     * @type {string}
     * @memberof NonceAttestation
     */
    challenge_id: string;
    /**
     * 
     * @type {ChallengeType}
     * @memberof NonceAttestation
     */
    challenge_type: ChallengeType;
    /**
     * 
     * @type {NonceAttestationData}
     * @memberof NonceAttestation
     */
    data?: NonceAttestationData;
}



/**
 * Check if a given object implements the NonceAttestation interface.
 */
export function instanceOfNonceAttestation(value: object): value is NonceAttestation {
    if (!('challenge_id' in value) || value['challenge_id'] === undefined) return false;
    if (!('challenge_type' in value) || value['challenge_type'] === undefined) return false;
    return true;
}

export function NonceAttestationFromJSON(json: any): NonceAttestation {
    return NonceAttestationFromJSONTyped(json, false);
}

export function NonceAttestationFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceAttestation {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge_id': json['challenge_id'],
        'challenge_type': ChallengeTypeFromJSON(json['challenge_type']),
        'data': json['data'] == null ? undefined : NonceAttestationDataFromJSON(json['data']),
    };
}

export function NonceAttestationToJSON(json: any): NonceAttestation {
    return NonceAttestationToJSONTyped(json, false);
}

export function NonceAttestationToJSONTyped(value?: NonceAttestation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_id': value['challenge_id'],
        'challenge_type': ChallengeTypeToJSON(value['challenge_type']),
        'data': NonceAttestationDataToJSON(value['data']),
    };
}

